import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@/components/ui/sonner'
import { api } from '@/lib/api'
import App from './App'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Initialize mocking
async function initMocking() {
  // Mocking is explicit opt-in for local development.
  const shouldMock = import.meta.env.VITE_ENABLE_MOCKS === 'true'
  
  if (!shouldMock) {
    return
  }

  
  // Use axios interceptor-based mocking
  const { setupAxiosMock } = await import('./mocks/axios-mock')
  setupAxiosMock(api)
}

// Start the app
// Multi-tenant branding: set favicon and title from branding-config.json
async function applyBranding() {
  try {
    const res = await fetch('/customers/branding-config.json');
    if (!res.ok) return;
    const config = await res.json();
    const domain = window.location.hostname;
    const branding = config[domain] || config['default'] || {};
    // Set favicon
    if (branding.favicon) {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = branding.favicon;
    }
    // Set title
    if (branding.title) {
      document.title = branding.title;
    }
  } catch (e) {
    // Ignore errors
  }
}

initMocking().then(() => {
  applyBranding().then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <App />
            <Toaster position="top-right" richColors closeButton />
          </BrowserRouter>
        </QueryClientProvider>
      </React.StrictMode>
    )
  });
});
